/* eslint-disable @typescript-eslint/ban-types */
import { FC, ReactElement, useState } from "react"
import { TasksService, Task, UpdateTaskRequestSchema } from "../sdk"
import { Controller, useForm } from "react-hook-form"
import Input from "./Input"
import Button from "./Button"
import classNames from "classnames"
import useError from "../hooks/useError"

type Props = {
  onSuccess?(task: Task): void
  defaultValues: Task
}

const EditTaskForm: FC<Props> = ({
  onSuccess,
  defaultValues: {
    title,
    materialsKey,
    pdfKey,
    maxScore,
    difficulty,
    id
  }
}) => {
  const [loading, setLoading] = useState<boolean>(false)

  const { handleSubmit, control, formState } = useForm<UpdateTaskRequestSchema["updates"]>()
  const { handleError } = useError()

  const onSubmit = async({
    title,
    materialsKey,
    pdfKey,
    maxScore,
    difficulty
  }: UpdateTaskRequestSchema["updates"]): Promise<void> => {
    setLoading(true)
    try {
      const { data } = await TasksService.updateTask({
        handler: { taskId: id },
        updates: {
          title,
          materialsKey: materialsKey || undefined,
          pdfKey,
          maxScore: Number(maxScore),
          difficulty: Number(difficulty)
        }
      })

      if (onSuccess) {
        onSuccess(data)
      }
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classNames(loading && "opacity-50 pointer-events-none")}>
      <Controller
        name="title"
        control={control}
        defaultValue={title}
        rules={{ required: "Campo Obbligatorio" }}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input className="mb-3" value={value} onChange={onChange} label="Titolo" error={formState.errors.title?.message} />
          )
        }}
      />
      <Controller
        name="materialsKey"
        control={control}
        defaultValue={materialsKey}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input className="my-3" value={value} onChange={onChange} label="Materiali" error={formState.errors.materialsKey?.message} />
          )
        }}
      />
      <Controller
        name="pdfKey"
        control={control}
        defaultValue={pdfKey}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input className="my-3" value={value} onChange={onChange} label="PDF" error={formState.errors.pdfKey?.message} />
          )
        }}
      />
      <Controller
        name="maxScore"
        control={control}
        rules={{ required: "Campo Obbligatorio" }}
        defaultValue={maxScore}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input className="my-3" value={value} onChange={onChange} label="Punteggio Massimo" error={formState.errors.maxScore?.message} />
          )
        }}
      />
      <Controller
        name="difficulty"
        control={control}
        rules={{ required: "Campo Obbligatorio" }}
        defaultValue={difficulty}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input className="mt-3" value={value} onChange={onChange} label="Difficoltà" error={formState.errors.difficulty?.message} />
          )
        }}
      />

      <Button type="submit" className="w-full mt-8">Salva</Button>
    </form>
  )
}

export default EditTaskForm


// updates: title, materialsKey, pdfKey, maxScore, difficulty